import Vue from 'vue';
import fetchData from '@/api/fetch';
import { message } from '@/tools/reset-message';
import { emitter, EMIT_DEFINE } from '@/tools/emitter';
import { checkUploadType, dealObjectValue } from '@/tools/utils';
import { Loading } from 'vhall-ui';
import log from 'loglevel';

Vue.prototype.$fetch = fetchData;
Vue.prototype.$vhMessage = message;
Vue.prototype.$emitter = emitter;
Vue.prototype.$EMIT_DEFINE = EMIT_DEFINE;
Vue.prototype.$checkUploadType = checkUploadType; // 验证上传格式
Vue.prototype.$params = dealObjectValue; //去除空值参数转换
Vue.prototype.$log = log;

// 全局loading方法
let loadingInstance;
Vue.prototype.$loading = function (
  options = {
    lock: true,
    text: '',
    spinner: '',
    customClass: 'custom-loading', //自定义类名
    background: 'rgba(255, 255, 255, 0.5)'
  }
) {
  loadingInstance = Loading.service(options);
};
Vue.prototype.$loadingClose = function () {
  if (loadingInstance) {
    Vue.nextTick(() => {
      loadingInstance.close();
    });
  }
};
